import { type ComponentProps, lazy } from 'react';

import { authModalComponentByType } from '#/modules/auth/modals/authModalComponentByType';
import { cmsModalComponentByType } from '#/modules/cms/modals/cmsModalComponentByType';
import { listingModalComponentByType } from '#/modules/listing/modals/listingModalComponentByType';
import { orgDashboardModalComponentByType } from '#/modules/orgDashboard/modals/orgDashboardModalComponentByType';
import { staffModalComponentByType } from '#/modules/staff/modals/staffModalComponentByType';
import { userDashboardModalComponentByType } from '#/modules/userDashboard/modals/userDashboardModalComponentByType';
import { userProfileModalComponentByType } from '#/modules/userProfile/modals/userProfileModalComponentByType';

/**
 * @deprecated Please DO NOT add more modals here
 *
 * ℹ️ Use the modal directly where you need it instead. Our app is quite large and listing modals like this means that any
 * new modal will add to the main bundle - reducing our bundle size is critical for good performance, improving UX and
 * SEO ranking. Even though we're including loadables and not the modal directly, the amount of modals we have (~80) add up.
 *
 * 🤷 The exception to this rule is the modals on `useShowUserModals` - until we have a redux-less infrastructure for that, triggering the modal through redux is still the way to go.
 *
 * 🙏 If you have a chance to remove one or more modals from here and make them local, please do so.
 *
 * Example: {showModal && <TheModalINeedToShow />}
 */
export const modalComponentByType = {
  CONFIRMATION: lazy(() =>
    import('#/modals/Confirmation/ConfirmationModalContainer').then(
      (module) => ({ default: module.ConfirmationModalContainer }),
    ),
  ),
  ADD_OR_EDIT_IMAGE: lazy(() =>
    import('#/modals/AddOrEditImage/AddOrEditImageModalContainer').then(
      (module) => ({ default: module.AddOrEditImageModalContainer }),
    ),
  ),
  MEDIA_GALLERY: lazy(() =>
    import('#/modals/MediaGallery/MediaGalleryModalContainer').then(
      (module) => ({ default: module.MediaGalleryModalContainer }),
    ),
  ),
  GENERIC_UNCLOSEABLE: lazy(() =>
    import('#/modals/GenericUncloseable/GenericUncloseableModal').then(
      (module) => ({ default: module.GenericUncloseableModal }),
    ),
  ),
  CROP_IMAGE: lazy(() =>
    import('#/components/ImagePicker/Internal/CropImageModal').then(
      (module) => ({ default: module.CropImageModal }),
    ),
  ),
  ...authModalComponentByType,
  ...cmsModalComponentByType,
  ...listingModalComponentByType,
  ...orgDashboardModalComponentByType,
  ...userProfileModalComponentByType,
  ...userDashboardModalComponentByType,
  ...staffModalComponentByType,
} as const satisfies Record<string, unknown>;

export type ModalPropsForType<TType extends keyof typeof modalComponentByType> =
  ComponentProps<(typeof modalComponentByType)[TType]>;
